var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BaseComponent } from '../../../utils/BaseComponent';
let Pages = class Pages extends BaseComponent {
    constructor() {
        super(...arguments);
        this.active = 0;
        this.showStepper = false;
        this.confirm = "Send inn";
        this.verify = () => {
            if (this.pages) {
                return !this.pages[this.active].verify || this.pages[this.active].verify();
            }
        };
    }
    firstUpdated() {
        const slot = this.shadowRoot.querySelector('slot');
        const children = slot === null || slot === void 0 ? void 0 : slot.assignedElements({ flatten: true });
        if (children) {
            // Set pages
            // @ts-ignore
            this.pages = children;
        }
    }
    render() {
        var _a;
        return html `
      <div class="flex flex-col w-full"
        @reset=${async () => {
            setTimeout(() => {
                this.active = 0;
            }, 300);
        }}
        @back=${(e) => {
            this.active -= 1;
            e.stopPropagation();
            e.preventDefault();
            this.dispatchEvent(new CustomEvent('back', { detail: { page: this.active + 1 }, bubbles: true, composed: true }));
        }}
        @next=${(e) => {
            if (this.verify()) {
                this.active += 1;
                e.stopPropagation();
                e.preventDefault();
                this.dispatchEvent(new CustomEvent('next', { detail: { page: this.active + 1 }, bubbles: true, composed: true }));
            }
        }}
      >
        ${this.pages ? this.pages[this.active] : nothing}
        ${this.showStepper ? html `
          <div class="mt-16 grow-0">
            <div class="flex justify-center">
              <div class="flex gap-16">
                ${(_a = this.pages) === null || _a === void 0 ? void 0 : _a.map((_, index) => html `
                  <span class="rounded-full ${index === this.active ? "bg-primary" : "bg-bluegray"} h-8 w-8" aria-label="step number ${index}: ${this.active === index ? "is active" : "is not active"}"></span>
                `)}
              </div>
          </div>
        </div>
        ` : nothing}
        <slot class="hidden"></slot>
      </div>
    `;
    }
};
__decorate([
    property()
], Pages.prototype, "classNames", void 0);
__decorate([
    property()
], Pages.prototype, "active", void 0);
__decorate([
    property({ type: Boolean })
], Pages.prototype, "showStepper", void 0);
__decorate([
    property()
], Pages.prototype, "confirm", void 0);
__decorate([
    state()
], Pages.prototype, "pages", void 0);
Pages = __decorate([
    customElement('trust-pages')
], Pages);
export { Pages };
//# sourceMappingURL=pages.js.map